import { __read } from "tslib";
import { isTabFilterKey, } from '@office-start/edgeworth-models';
import { IconNames } from '@office-start/fabric-icon-subset-utility';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { CustomFilterType, FilterType, } from '../models/Filters';
import { getCustomPivotTabId } from '../utilities/getCustomPivotTabId';
import { getFilterModelFromCustomPivot } from '../utilities/getFilterModelFromCustomPivot';
import { getFiltersFromConfig } from '../utilities/getFiltersFromConfig';
import { getFiltersMap } from '../utilities/getFiltersMap';
export function useTabsFilter(locResources, onSelectTab, customPivots, getCustomPivotTitle, getCustomPivotIconElement, PendingCustomPivotId, activeCustomPivotTabId, fetchPictureData, tagMap, identity, msaUserHint, getTagIdByTagValue, onPivotRefChange, filtersConfig, customFiltersEnabled) {
    var filtersMap = useMemo(function () { return getFiltersMap(false, msaUserHint, undefined, identity); }, [identity, msaUserHint]);
    var _a = __read(useState((identity === null || identity === void 0 ? void 0 : identity.isMsa) ? 'recent' : 'all'), 2), currentTab = _a[0], setCurrentTab = _a[1];
    var tabFilters = useMemo(function () {
        var selectedCustomPivot = customPivots
            ? customPivots.find(function (customPivot) {
                return currentTab === getCustomPivotTabId(customPivot);
            })
            : undefined;
        if (!isTabFilterKey(currentTab) &&
            (!customPivots || !selectedCustomPivot)) {
            return [];
        }
        if (filtersMap.has(currentTab)) {
            return [
                {
                    filterId: currentTab,
                    filterFunction: filtersMap.get(currentTab),
                    filterType: FilterType.Tabs,
                },
            ];
        }
        else {
            if (selectedCustomPivot &&
                selectedCustomPivot.customFilterType !==
                    CustomFilterType.Pending) {
                var isTagFilterType = selectedCustomPivot.customFilterType ===
                    CustomFilterType.Tag ||
                    selectedCustomPivot.customFilterType ===
                        CustomFilterType.Tagv2;
                var filterModel = getFilterModelFromCustomPivot(selectedCustomPivot, isTagFilterType ? tagMap : undefined, getTagIdByTagValue);
                return [filterModel];
            }
            else {
                return [];
            }
        }
    }, [currentTab, customPivots, filtersMap, tagMap, getTagIdByTagValue]);
    var filterTabs = useMemo(function () {
        var filters = customFiltersEnabled && filtersConfig
            ? getFiltersFromConfig(filtersConfig, locResources, onPivotRefChange)
            : [
                {
                    id: 'all',
                    title: locResources.allPivotLabel,
                    iconName: IconNames.Layer,
                },
                {
                    id: 'recent',
                    title: locResources.recentPivotLabel,
                    iconName: IconNames.Clock,
                },
                {
                    id: 'shared',
                    title: locResources.sharedPivotLabel,
                    iconName: IconNames.People,
                },
                {
                    id: 'favorites',
                    title: locResources.favoritesPivotLabel,
                    iconName: IconNames.FavoriteStar,
                    onPivotRefChange: onPivotRefChange
                        ? function (element) {
                            return onPivotRefChange('favorites', element);
                        }
                        : undefined,
                },
            ];
        return filters.filter(function (pivotItem) { return filtersMap.has(pivotItem.id); });
    }, [
        customFiltersEnabled,
        filtersConfig,
        filtersMap,
        locResources,
        onPivotRefChange,
    ]);
    var tabs = useMemo(function () {
        if (customPivots && getCustomPivotTitle && getCustomPivotIconElement) {
            return filterTabs.concat(customPivots.map(function (customPivot) {
                var tabId = getCustomPivotTabId(customPivot);
                return {
                    id: tabId,
                    title: getCustomPivotTitle(customPivot) || '',
                    iconName: tabId === PendingCustomPivotId ? IconNames.Add : '',
                    iconElement: getCustomPivotIconElement(customPivot, fetchPictureData),
                    isCustomPivot: true,
                };
            }));
        }
        else {
            return filterTabs;
        }
    }, [
        PendingCustomPivotId,
        customPivots,
        fetchPictureData,
        filterTabs,
        getCustomPivotIconElement,
        getCustomPivotTitle,
    ]);
    useEffect(function () {
        if (activeCustomPivotTabId && activeCustomPivotTabId !== currentTab) {
            setCurrentTab(activeCustomPivotTabId);
        }
    }, [activeCustomPivotTabId, currentTab]);
    var wrappedOnSelectTab = useCallback(function (tabEvent) {
        var tabId = tabEvent.tabId;
        setCurrentTab(tabId);
        if (onSelectTab) {
            onSelectTab(tabEvent);
        }
    }, [onSelectTab]);
    return useMemo(function () { return ({
        pivotProps: {
            tabs: tabs,
            onSelectTab: wrappedOnSelectTab,
        },
        activeFilters: tabFilters,
        currentTab: currentTab,
    }); }, [currentTab, tabFilters, tabs, wrappedOnSelectTab]);
}
//# sourceMappingURL=useTabsFilter.js.map